
(function(){
  const P={wine:'#580431',accent:'#9f4e6a',sky:'#cdebf4',skyDeep:'#b9dfea',
           yellow:'#ffe682',pink:'#f6cfdf',pinkDeep:'#f2b9d0',paper:'#fffdf9'};

  /* ---------- shared animals: droopy-eared dog, pointy-eared cat ---------- */
  const DOG_L='M44 48 C33 46 27 59 29.5 73 C31 82 39 85 44.5 79 C41 68 41.5 56 44 48 Z';
  const DOG_R='M76 48 C87 46 93 59 90.5 73 C89 82 81 85 75.5 79 C79 68 78.5 56 76 48 Z';
  const CAT_L='M45 51 L38 30 L58 43 Z';
  const CAT_R='M75 51 L82 30 L62 43 Z';

  /* the cat's read lives in the silhouette — nothing pale below the eyes
     but the nose, or it turns into a snout at icon size */
  const cat=(b,e,n)=>`
    <g fill="${b}"><path d="${CAT_L}"/><path d="${CAT_R}"/>
      <ellipse cx="60" cy="63" rx="19.5" ry="16.5"/></g>
    <g fill="${e}"><circle cx="52" cy="60" r="3.4"/><circle cx="68" cy="60" r="3.4"/></g>
    <path d="M60 69 l-3.4 3 h6.8 z" fill="${n}"/>`;

  /* head AND shoulders with a bow tie, cropped off the bottom of the mat —
     a floating head read as an icon rather than a piece of wall art */
  const dogBust=()=>`
    <ellipse cx="60" cy="104" rx="27" ry="20" fill="${P.wine}"/>
    <path d="M60 86 l-11.5 -6.5 v13 z" fill="${P.yellow}"/>
    <path d="M60 86 l11.5 -6.5 v13 z" fill="${P.yellow}"/>
    <circle cx="60" cy="86" r="3.4" fill="${P.yellow}"/>
    <g fill="${P.wine}"><path d="${DOG_L}"/><path d="${DOG_R}"/>
      <ellipse cx="60" cy="62" rx="19" ry="17"/></g>
    <ellipse cx="60" cy="72" rx="9.5" ry="7" fill="${P.pinkDeep}"/>
    <ellipse cx="60" cy="67.5" rx="3.4" ry="2.6" fill="${P.wine}"/>
    <g fill="${P.paper}"><circle cx="52.5" cy="59" r="2.8"/><circle cx="67.5" cy="59" r="2.8"/></g>`;

  const at=(x,y,s,i)=>`<g transform="translate(${x} ${y}) scale(${s}) translate(-60 -62)">${i}</g>`;
  const SPARK='M60 34 C62.5 50.5 69.5 57.5 86 60 C69.5 62.5 62.5 69.5 60 86 C57.5 69.5 50.5 62.5 34 60 C50.5 57.5 57.5 50.5 60 34 Z';
  const spark=(x,y,s,f)=>`<g transform="translate(${x} ${y}) scale(${s}) translate(-60 -60)"><path d="${SPARK}" fill="${f}"/></g>`;
  const disc=f=>`<circle cx="60" cy="60" r="45" fill="${f}"/>`;
  const SH='url(#pcM)';

  const scenes=[
   /* 1 — three DIFFERENT kinds of artwork: abstract, landscape, pet portrait */
   ()=>`${disc(P.yellow)}
    <g filter="${SH}">
      <g transform="rotate(-11 29 61)">
        <rect x="14" y="42" width="30" height="38" rx="2.5" fill="${P.paper}"/>
        <rect x="17.5" y="45.5" width="23" height="31" rx="1.5" fill="${P.skyDeep}"/>
        <circle cx="24.5" cy="54" r="5" fill="${P.accent}"/>
        <rect x="31" y="51" width="8" height="8" rx="1" fill="${P.yellow}"/>
        <path d="M18 70 h21 v6 h-21 z" fill="${P.wine}"/>
      </g>
      <g transform="rotate(11 91 61)">
        <rect x="76" y="42" width="30" height="38" rx="2.5" fill="${P.paper}"/>
        <rect x="79.5" y="45.5" width="23" height="31" rx="1.5" fill="${P.pink}"/>
        <circle cx="96" cy="53" r="4.5" fill="${P.yellow}"/>
        <path d="M79.5 76.5 v-9 l8-9 7 8 5-5 3 3 v12 z" fill="${P.accent}"/>
      </g>
      <g><rect x="40" y="28" width="40" height="50" rx="2.5" fill="${P.paper}"/>
        <rect x="44" y="32" width="32" height="36" rx="1.5" fill="${P.sky}"/>
        ${at(60,49,0.42,cat(P.wine,P.sky,P.pink))}</g>
    </g>
    <g filter="${SH}"><circle cx="83" cy="80" r="13.5" fill="${P.wine}"/>
      <path d="M77 80 l4.5 4.5 8.5-9.5" fill="none" stroke="${P.yellow}" stroke-width="3.6"
            stroke-linecap="round" stroke-linejoin="round"/></g>`,
   /* 2 — upload */
   ()=>`${disc(P.pink)}
    <g filter="${SH}">
      <rect x="24" y="52" width="72" height="46" rx="4" fill="${P.paper}"/>
      <rect x="31" y="59" width="58" height="32" rx="2" fill="${P.skyDeep}"/>
      <circle cx="76" cy="68" r="5.5" fill="${P.yellow}"/>
      <path d="M31 91 v-7 l16-15 12 12 9-9 21 19 z" fill="${P.accent}"/>
    </g>
    <g filter="${SH}"><path d="M53 46 V25 h-10 L60 7 l17 18 h-10 v21 z" fill="${P.wine}"/></g>`,
   /* 3 — the preview, as a finished wall-art piece */
   ()=>`${disc(P.skyDeep)}
    <g filter="${SH}">
      <rect x="33" y="18" width="54" height="84" rx="3" fill="${P.paper}"/>
      <g clip-path="url(#pkArt)">
        <rect x="38" y="23" width="44" height="74" rx="1.5" fill="${P.sky}"/>
        <g transform="translate(60 61) scale(0.76) translate(-60 -70)">${dogBust()}</g>
      </g>
    </g>
    ${spark(100,22,0.40,P.yellow)}${spark(20,94,0.28,P.yellow)}${spark(104,84,0.22,P.yellow)}`,
   /* 4 — order: panel peeking out of the bag on the LEFT, clear of the handle */
   ()=>`${disc(P.accent)}
    <g filter="${SH}"><path d="M46 58 V48 a15 15 0 0 1 30 0 v10 h-8 V48 a7 7 0 0 0-14 0 v10 z" fill="${P.pinkDeep}"/></g>
    <g filter="${SH}" transform="rotate(-13 40 52)">
      <rect x="24" y="30" width="32" height="40" rx="2" fill="${P.paper}"/>
      <rect x="29" y="35" width="22" height="26" rx="1.5" fill="${P.pinkDeep}"/></g>
    <g filter="${SH}"><path d="M27 57 h66 l-5 46 H32 Z" fill="${P.yellow}"/>
      <path d="M60 95 C45.5 84.5 42 76 47 70.5 c4-4.3 10.3-2.4 13 2.7 2.7-5.1 9-7 13-2.7 5 5.5 1.5 14-13 24.5 Z" fill="${P.wine}"/></g>
    ${spark(100,30,0.24,P.yellow)}`
  ];

  /* Every word capitalised (owner, 2026-09-19). Changed in the copy itself
     rather than with text-transform:capitalize, so what ships is what is
     written — the CSS trick leaves the source lower-case and silently
     re-cases it at render time. */
  const LABELS=['Select Any Of Our<br>Portrait Designs','Upload<br>Your Photo',
                'Instantly See<br>Your Preview','Love It?<br>Order It!'];

  const arrow=()=>`<svg viewBox="0 0 44 30" aria-hidden="true">
      <g filter="${SH}"><path d="M2 11 h24 V4 l16 11 -16 11 v-7 H2 z" fill="${P.wine}"/></g></svg>`;

  /* B4 "Comic Pow" */
  const timeBadge=()=>`
    <div class="timebadge">
      <svg viewBox="0 0 240 126" aria-hidden="true">
        <path d="M6 62 L42 36 L34 10 L78 28 L116 4 L136 30 L182 14 L184 42 L236 58 L188 80 L208 112 L158 98 L124 122 L100 96 L54 110 L50 80 Z" fill="${P.yellow}"/>
      </svg>
      <span class="timebadge__text">
        <span class="timebadge__t1">Only</span><span class="timebadge__t2">2 Minutes!</span>
      </span>
    </div>`;

  function flow(){
    let h='<div class="flow">';
    LABELS.forEach((label,i)=>{
      h+=`<div class="flow__step"><div class="flow__art">
            <svg viewBox="0 0 120 120" role="img" aria-label="Step ${i+1}: ${label.replace(/<br>/g,' ')}">${scenes[i]()}</svg>
          </div><p class="flow__label">${label}</p></div>`;
      if(i<3){ const t=(i===1);
        h+=`<div class="flow__conn${t?' flow__conn--time':''}">${t?timeBadge():''}${arrow()}</div>`; }
    });
    return h+'</div>';
  }

  /* ---------- S4 "Colour Blocks" steps (owner 2026-09-23) — flat single-colour glyphs:
     g = shape colour, b = cut-out colour (the block behind). Same drawings as steps-variants.html. */
  const FS_COLS=['#5BA1D7','#D75B99','#FA9338','#31BFC4'];   // Fashion Name blue, pink, orange, teal
  const flatDog=(g,b)=>`<g fill="${g}"><path d="${DOG_L}"/><path d="${DOG_R}"/><ellipse cx="60" cy="62" rx="19" ry="17"/></g>
    <g fill="${b}"><circle cx="52.5" cy="59" r="3"/><circle cx="67.5" cy="59" r="3"/><ellipse cx="60" cy="68.5" rx="3.8" ry="2.9"/></g>`;
  const FS_ICONS=[
   (g,b)=>`<g transform="rotate(-12 30 66)"><rect x="10" y="46" width="38" height="46" rx="4" fill="${g}"/><rect x="16" y="52" width="26" height="34" rx="2" fill="${b}"/><circle cx="29" cy="62" r="5" fill="${g}"/><path d="M16 86 V80 L25 72 L33 79 L42 71 V86 Z" fill="${g}"/></g>
     <g transform="rotate(12 90 66)"><rect x="72" y="46" width="38" height="46" rx="4" fill="${g}"/><rect x="78" y="52" width="26" height="34" rx="2" fill="${b}"/><path d="M78 86 V74 L91 62 L104 74 V86 Z" fill="${g}"/></g>
     <rect x="33" y="18" width="54" height="72" rx="5" fill="${g}" stroke="${b}" stroke-width="5"/><rect x="40" y="25" width="40" height="58" rx="2" fill="${b}"/>${at(60,56,0.52,flatDog(g,b))}
     <rect x="46" y="72" width="28" height="4" rx="2" fill="${g}"/>`,
   (g,b)=>`<path d="M60 6 L85 32 H71 V50 H49 V32 H35 Z" fill="${g}"/>
     <rect x="16" y="56" width="88" height="56" rx="7" fill="${g}"/><rect x="24" y="64" width="72" height="40" rx="3" fill="${b}"/>
     <path d="M24 104 V96 L45 75 L59 89 L70 78 L96 102 V104 Z" fill="${g}"/><circle cx="83" cy="76" r="6" fill="${g}"/>`,
   (g,b)=>`<rect x="31" y="6" width="58" height="108" rx="12" fill="${g}"/><rect x="38" y="18" width="44" height="82" rx="4" fill="${b}"/>
     ${at(60,58,0.6,flatDog(g,b))}<rect x="44" y="84" width="32" height="5" rx="2.5" fill="${g}"/><rect x="52" y="105" width="16" height="3.5" rx="1.75" fill="${b}"/>
     ${spark(104,24,.44,g)}${spark(16,92,.3,g)}`,
   (g,b)=>`<path d="M43 52 V40 a17 17 0 0 1 34 0 V52" fill="none" stroke="${g}" stroke-width="8" stroke-linecap="round"/>
     <path d="M18 48 H102 L95 112 H25 Z" fill="${g}"/>
     <path d="M60 100 C43 89 38 80 43.5 73.5 c4.5-5 12-3 16.5 3 4.5-6 12-8 16.5-3 5.5 6.5 0.5 15.5-16.5 26.5 Z" fill="${b}"/>`
  ];
  const FS_ARROW=`<svg viewBox="0 0 44 30" aria-hidden="true"><path d="M2 11 h24 V4 l16 11 -16 11 v-7 H2 z" fill="#261b24"/></svg>`;
  function flowS4(){
    let h='<div class="fs-flow">';
    LABELS.forEach((label,i)=>{
      h+=`<div class="fs-step" style="background:${FS_COLS[i]}"><div class="fs-ic">
            <svg viewBox="0 0 120 120" role="img" aria-label="Step ${i+1}: ${label.replace(/<br>/g,' ')}">${FS_ICONS[i]('#fff',FS_COLS[i])}</svg>
          </div><p class="fs-lb">${label}</p></div>`;
      if(i<3) h+= i===1 ? `<div class="fs-conn"><span class="fs-badge">Only 2 Minutes!</span></div>`
                        : `<div class="fs-conn">${FS_ARROW}</div>`;
    });
    return h+'</div>';
  }

  /* ---------- S2 "Big Numbers" steps (owner 2026-09-23: "change it out with S2") ---------- */
  /* flat 2D stopwatch: ink ring, crown + side button, a Fashion Name red wedge for the elapsed time, one hand */
  const NS_WATCH=`<svg class="ns-watch" viewBox="0 0 40 44" aria-hidden="true">
      <rect x="16.5" y="1" width="7" height="4" rx="1.2" fill="#261b24"/><rect x="18.8" y="4" width="2.4" height="5" fill="#261b24"/>
      <rect x="30.5" y="7.2" width="6" height="3.4" rx="1.2" fill="#261b24" transform="rotate(45 33.5 8.9)"/>
      <circle cx="20" cy="26" r="15.5" fill="#fff" stroke="#261b24" stroke-width="3.6"/>
      <path d="M20 26 V14 A12 12 0 0 1 30.39 32 Z" fill="#F25F61"/>
      <path d="M20 26 L30.39 32" stroke="#261b24" stroke-width="2.6" stroke-linecap="round"/>
      <circle cx="20" cy="26" r="2.4" fill="#261b24"/></svg>`;
  function flowS2(){
    let h='<div class="ns-flow">';
    LABELS.forEach((label,i)=>{
      h+=`<div class="ns-step"><span class="ns-num" style="color:${FS_COLS[i]}" aria-hidden="true">${i+1}</span>
            <p class="ns-lb">${label}</p></div>`;
      if(i<3) h+= i===1 ? `<div class="ns-conn ns-conn--time">${NS_WATCH}<span class="ns-time">Only 2 Minutes!</span>${FS_ARROW}</div>`
                        : `<div class="ns-conn">${FS_ARROW}</div>`;
    });
    return h+'</div>';
  }

  const topBars=()=>`
    <div class="shopify-announcement">BUY 2, SAVE 10% &middot; BUY 3+, SAVE 23%</div>
    <div class="shopify-style-header">
      <a class="shopify-collection-link" href="#">
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="m8.25 4.5 2.1 1.65h3.3l2.1-1.65 4.25 2.6-2.15 3.5-1.85-1V20H8V9.6l-1.85 1L4 7.1l4.25-2.6Z"></path>
          <path d="M10.35 6.15c.35 1.25 2.95 1.25 3.3 0"></path></svg><span>Outfit Collection</span></a>
      <a class="shopify-wordmark" href="/" aria-label="Pocketry home">
        <img src="https://pocketry-site-media-744329357706.us-west1.run.app/pocketrylogo.png" width="771" height="199" alt="Pocketry"></a>
      <nav class="shopify-header-actions" aria-label="Shopping cart">
        <a class="shopify-header-action" href="#">
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M3 4h2.25l1.9 9.15a2 2 0 0 0 1.95 1.6h7.8a2 2 0 0 0 1.95-1.55L20 8H6.1"></path>
            <circle cx="9.25" cy="19" r="1.25"></circle><circle cx="17.25" cy="19" r="1.25"></circle>
          </svg><span>Cart</span></a></nav>
    </div>
    <div class="ptab-wrap"><div class="ptab">Printed in Scottsdale, Arizona</div></div>`;

  /* Each slide carries its OWN focal point. The library is mostly square
     — only wall-art-sizes-4 (2.00:1) and office-wall-5 (1.46:1) are wider
     than tall — so in a 2.5:1 band the squarer shots lose most of their
     height and have to be aimed by hand. */
  /* `max` is the largest derivative that exists for each slide, rebuilt by
     DOWNSCALING the full-size originals in ~/Desktop/POCKETRY MAIN
     FOLDER/Sitephotos (3000-5700px wide). Nothing is upscaled, so no
     Topaz pass is involved. A slide stops at 2400 only because its own
     original is ~3000px and going further would be invention. */
  const SLIDES = [
    {b:'office-wall-5',        w:1000,h:684, max:3200, pos:'50% 42%', alt:'A gallery wall of Pocketry dog portraits'},
    {b:'wall-art-sizes-4',     w:1000,h:499, max:2400, pos:'50% 50%', alt:'The King portrait shown in all four Pocketry wall-art sizes'},
    {b:'macy-boss',            w:1000,h:878, max:2400, pos:'50% 38%', alt:'Macy beside her Pocketry Boss portrait'},
    {b:'scooter-pickleballer', w:1000,h:907, max:2400, pos:'50% 38%', alt:'Scooter beside his Pocketry Pickleballer portrait'},
    {b:'milton-nurse-3',       w:1000,h:954, max:3200, pos:'50% 34%', alt:'Milton beside his Pocketry Nurse portrait'}
  ];

  const srcsetFor = s =>
    [320,640,1000,1600,2400,3200].filter(w=>w<=s.max)
      .map(w=>`${s.b}-web-${w}.webp ${w}w`).join(', ');

  const slides = () => SLIDES.map((s,i)=>`
      <img class="hero__img${i===0?' is-on':''}" src="${s.b}-web-1600.webp"
           srcset="${srcsetFor(s)}"
           sizes="100vw" width="${s.w}" height="${s.h}" alt="${i===0?s.alt:''}"
           style="object-position:${s.pos}"
           ${i===0?'loading="eager" fetchpriority="high"':'loading="eager"'} decoding="async">`).join('');

  const dots = () => SLIDES.map((s,i)=>
      `<button type="button" data-slide="${i}" aria-current="${i===0}"
               aria-label="Photo ${i+1} of ${SLIDES.length}"></button>`).join('');

  let timer=null, idx=0;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  function show(n){
    const imgs=[...document.querySelectorAll('.hero__img')];
    if(!imgs.length) return;
    idx=(n+imgs.length)%imgs.length;
    imgs.forEach((im,i)=>im.classList.toggle('is-on', i===idx));
    document.querySelectorAll('.hero__dots button')
      .forEach((b,i)=>b.setAttribute('aria-current', String(i===idx)));
  }

  function rotate(ms){
    if(timer){ clearInterval(timer); timer=null; }
    /* honour the OS setting: no auto-rotation, first slide only */
    if(!ms || reduced.matches) return;
    timer=setInterval(()=>show(idx+1), ms);
  }

  /* Four empty squares. Contents not decided — placeholders only. */
  /* Rows one and two are real: eight outfits, each shown with the ORIGINAL
     photo of the same dog that produced that portrait. Each row carries its
     own tile background (`bg`) — the grey placeholder matched the studio
     grey inside the artwork exactly (1.00:1), so the artwork had no edge.
     Rows three to five are still placeholders. */
  /* owner 2026-09-22 (latest): "change all backgrounds of each row on the homepage to WHITE. But create a thin
     outline around each square area in Shade 2 from our gray list" -> tile colour #ffffff; outline #9e9e9e
     (dog-row-greys.html Shade 2), see .tile__box in the CSS. Replaces grey Shade 4 #525252. */
  /* owner 2026-09-22 (later): "change all rows on the homepage to Shade 4" -> grey Shade 4 #525252
     (dog-row-greys.html, the page just reviewed). Replaces Shade 3 blue #79c9e2. */
  /* owner 2026-09-22: "change all rows on the homepage version to have the background color of Shade 3"
     -> every row's tile colour = #79c9e2 (brand sky hue 194, S .64, L .68; dog-row-blues.html).
     Per-row colours before this: #ffe682, #ffe682, #fbf7f1, #cdebf4, #9f4e6a, #9f4e6a, #fbf7f1, #cdebf4, #cdebf4 */
  /* owner 2026-10-05: ALL-DESIGNS version -- "include all of our new product designs. Have each design take up one row of 4
     images (variations)... reduce [Outfits, Fashion Name, Ink Wash] to only one row... remove ... the staging photos".
     One row per design, no room strips. Original homepage.html untouched. New tiles: https://pocketry-site-media-744329357706.us-west1.run.app/nd/ (build_all_designs_assets.py). */
  const GROUPS = [
    /* owner 2026-10-17: "add a new row above Fashion Name Series and just put a title of DOG PORTRAITS for now" --
       The King (Ham), Fashion Name Pink (Lucy), Ink Wash Orange (Warren), Watercolor Morph (Leo); Oct 11 shoot photos.
       Previous version: _versions/homepage-shoot-photos__2026-10-12_before-dog-portraits-row.html */
    { head:'DOG PORTRAITS', bg:'#ffffff', items:[   /* owner 2026-10-17: all four on the Sofia & Milo panel photo, blue wall (heroes/king_on_sofia_panel_2026_10_17.py) */
        {photo:'shoot/king-on-sofia-panel-rp-blue', cap:'The King - Dog Portrait'},   /* owner 2026-10-17: King render on the Sofia & Milo panel photo, blue wall (was oc-king_french-bulldog-rp-blue) */
        {photo:'shoot/leo-wm-on-sofia-panel-rp-blue', cap:'Watercolor Morph - Dog Portrait'},
        {photo:'shoot/warren-iw-on-sofia-panel-rp-blue', cap:'Ink Wash Orange - Dog Portrait'},
        {photo:'shoot/lucy-fn-on-sofia-panel-rp-blue', cap:'Fashion Name Pink - Dog Portrait'} ] },   /* order: owner 2026-10-17 "King, Watercolor, Ink Wash, Fashion Name" */
    { head:'FASHION NAME SERIES', forWho:'Dogs', bg:'#ffffff', items:[
        {art:'https://pocketry-site-media-744329357706.us-west1.run.app/fn-art-ham-blue_d2.webp',     refs:["https://pocketry-site-media-744329357706.us-west1.run.app/fn-ref-ham.webp"],     name:'Fashion Name Blue',   dog:'Ham',     style:'Fashion Name', land:false},
        {art:'https://pocketry-site-media-744329357706.us-west1.run.app/fn-art-betty-pink_d2.webp',   refs:["https://pocketry-site-media-744329357706.us-west1.run.app/fn-ref-betty.webp"],   name:'Fashion Name Pink',   dog:'Betty',   style:'Fashion Name', land:false},
        {art:'https://pocketry-site-media-744329357706.us-west1.run.app/fn-art-guapo-grey_d2.webp',   refs:["https://pocketry-site-media-744329357706.us-west1.run.app/fn-ref-guapo.webp"],   name:'Fashion Name Gray',   dog:'Guapo',   style:'Fashion Name', land:false},
        {art:'https://pocketry-site-media-744329357706.us-west1.run.app/fn-art-lucy-orange_d2.webp',  refs:["https://pocketry-site-media-744329357706.us-west1.run.app/fn-ref-lucy.webp"],    name:'Fashion Name Orange', dog:'Lucy',    style:'Fashion Name', land:false} ] },
    { head:'OUTFIT COLLECTION', forWho:'Dogs',   /* was DOG "FAKE PHOTOSHOOT" COLLECTION -- owner 2026-09-23 */ script:'See all 18 outfits', bg:'#ffffff', items:[   /* brand yellow — owner 2026-09-21 */
        {slug:'king',         name:'The King',          dog:'Warren'},
        {slug:'nurse',        name:'The Nurse',         dog:'Milton'},
        {slug:'chef',         name:'The Chef',          dog:'Ham'},
        {slug:'pickleballer', name:'The Pickleballer',  dog:'Scooter'} ] },
    { head:'INK WASH SERIES', forWho:'Dogs', bg:'#ffffff', items:[   /* was 'INK WASH SERIES' — DOG added 2026-09-23 to match the cat section */
        {art:'https://pocketry-site-media-744329357706.us-west1.run.app/iw-art-moose-blue_d2.webp', refs:["https://pocketry-site-media-744329357706.us-west1.run.app/iw-ref-moose.webp"], name:'Ink Wash Blue', dog:'Moose', style:'Ink Wash', land:false},
        {art:'https://pocketry-site-media-744329357706.us-west1.run.app/iw-art-betty-leo-pink_neon.webp', refs:["https://pocketry-site-media-744329357706.us-west1.run.app/iw-ref-betty.webp", "https://pocketry-site-media-744329357706.us-west1.run.app/iw-ref-leo.webp"], name:'Ink Wash Pink', dog:'Betty & Leo', style:'Ink Wash', land:true},
        {art:'https://pocketry-site-media-744329357706.us-west1.run.app/iw-art-widow-orange_d2.webp', refs:["https://pocketry-site-media-744329357706.us-west1.run.app/iw-ref-widow.webp"], name:'Ink Wash Orange', dog:'Widow', style:'Ink Wash', land:false},
        {art:'https://pocketry-site-media-744329357706.us-west1.run.app/iw-art-guapo-ham-teal.webp', refs:["https://pocketry-site-media-744329357706.us-west1.run.app/iw-ref-guapo.webp", "https://pocketry-site-media-744329357706.us-west1.run.app/iw-ref-ham.webp"], name:'Ink Wash Teal', dog:'Guapo & Ham', style:'Ink Wash', land:true} ] },
    { head:"WATERCOLOR MORPH", forWho:"Dogs", bg:'#ffffff', items:[
        {"art": "https://pocketry-site-media-744329357706.us-west1.run.app/nd/wm-lucy.webp", "refs": ["https://pocketry-site-media-744329357706.us-west1.run.app/fn-ref-lucy.webp"], "cap": "Watercolor Morph - Dog Portrait", "land": false},
        {"art": "https://pocketry-site-media-744329357706.us-west1.run.app/nd/wm-monty-malti.webp", "refs": ["https://pocketry-site-media-744329357706.us-west1.run.app/iw-ref-monty.webp", "https://pocketry-site-media-744329357706.us-west1.run.app/iw-ref-malti.webp"], "cap": "Watercolor Morph - Two-Dog Portrait", "land": true},
        {"art": "https://pocketry-site-media-744329357706.us-west1.run.app/nd/wm-leo.webp", "refs": ["https://pocketry-site-media-744329357706.us-west1.run.app/iw-ref-leo.webp"], "cap": "Watercolor Morph - Dog Portrait", "land": false},
        {"art": "https://pocketry-site-media-744329357706.us-west1.run.app/nd/wm-luke-moose.webp", "refs": ["https://pocketry-site-media-744329357706.us-west1.run.app/fn-ref-luke.webp", "https://pocketry-site-media-744329357706.us-west1.run.app/iw-ref-moose.webp"], "cap": "Watercolor Morph - Two-Dog Portrait", "land": true} ] },
    { head:'FASHION NAME SERIES', forWho:'Cats', bg:'#ffffff', items:[
        {art:'https://pocketry-site-media-744329357706.us-west1.run.app/fn-art-cat-siam-blue_d2.webp', refs:["https://pocketry-site-media-744329357706.us-west1.run.app/fn-ref-cat-siam.webp"], name:'Fashion Name Blue', dog:'Siam', species:'Cat', style:'Fashion Name', land:false},
        {art:'https://pocketry-site-media-744329357706.us-west1.run.app/fn-art-cat-bobby-pink_d2.webp', refs:["https://pocketry-site-media-744329357706.us-west1.run.app/fn-ref-cat-bobby.webp"], name:'Fashion Name Pink', dog:'Bobby', species:'Cat', style:'Fashion Name', land:false},
        {art:'https://pocketry-site-media-744329357706.us-west1.run.app/fn-art-cat-spotty-grey_d2.webp', refs:["https://pocketry-site-media-744329357706.us-west1.run.app/fn-ref-cat-spotty.webp"], name:'Fashion Name Gray', dog:'Spotty', species:'Cat', style:'Fashion Name', land:false},
        {art:'https://pocketry-site-media-744329357706.us-west1.run.app/fn-art-cat-jonah-orange_d2.webp', refs:["https://pocketry-site-media-744329357706.us-west1.run.app/fn-ref-cat-jonah.webp"], name:'Fashion Name Orange', dog:'Jonah', species:'Cat', style:'Fashion Name', land:false} ] },
    { head:'OUTFIT COLLECTION', forWho:'Cats',   /* was CAT "FAKE PHOTOSHOOT" COLLECTION -- owner 2026-09-23 */ script:'See all 16 outfits', bg:'#ffffff', items:[   /* accent plum */
        {slug:'cat-sailor', name:'The Sailor', dog:'Siam', species:'Cat'},
        {slug:'cat-yogi', name:'The Yogi', dog:'Tabitha', species:'Cat'},
        {slug:'cat-nurse', name:'The Nurse', dog:'Spotty', species:'Cat'},
        {slug:'cat-golfer', name:'The Golfer', dog:'Macky', species:'Cat'} ] },
    { head:'INK WASH SERIES', forWho:'Cats', bg:'#ffffff', items:[
        {art:'https://pocketry-site-media-744329357706.us-west1.run.app/iw-art-cat-siam-blue_d2.webp', refs:["https://pocketry-site-media-744329357706.us-west1.run.app/iw-ref-cat-siam.webp"], name:'Ink Wash Blue', dog:'Siam', species:'Cat', style:'Ink Wash', land:false},
        {art:'https://pocketry-site-media-744329357706.us-west1.run.app/iw-art-cat-bobby-jonah-pink_neon.webp', refs:["https://pocketry-site-media-744329357706.us-west1.run.app/iw-ref-cat-bobby.webp", "https://pocketry-site-media-744329357706.us-west1.run.app/iw-ref-cat-jonah.webp"], name:'Ink Wash Pink', dog:'Bobby & Jonah', species:'Cat', style:'Ink Wash', land:true},
        {art:'https://pocketry-site-media-744329357706.us-west1.run.app/iw-art-cat-tabitha-orange_d2.webp', refs:["https://pocketry-site-media-744329357706.us-west1.run.app/iw-ref-cat-tabitha.webp"], name:'Ink Wash Orange', dog:'Tabitha', species:'Cat', style:'Ink Wash', land:false},
        {art:'https://pocketry-site-media-744329357706.us-west1.run.app/iw-art-cat-gingy-macky-teal.webp', refs:["https://pocketry-site-media-744329357706.us-west1.run.app/iw-ref-cat-gingy.webp", "https://pocketry-site-media-744329357706.us-west1.run.app/iw-ref-cat-macky.webp"], name:'Ink Wash Teal', dog:'Gingy & Macky', species:'Cat', style:'Ink Wash', land:true} ] },
    { head:"WATERCOLOR MORPH", forWho:"Cats", bg:'#ffffff', items:[
        {"art": "https://pocketry-site-media-744329357706.us-west1.run.app/nd/wm-cat-siam.webp", "refs": ["https://pocketry-site-media-744329357706.us-west1.run.app/fn-ref-cat-siam.webp"], "cap": "Watercolor Morph - Cat Portrait", "land": false},
        {"art": "https://pocketry-site-media-744329357706.us-west1.run.app/nd/wm-cat-siam-macky.webp", "refs": ["https://pocketry-site-media-744329357706.us-west1.run.app/fn-ref-cat-siam.webp", "https://pocketry-site-media-744329357706.us-west1.run.app/iw-ref-cat-macky.webp"], "cap": "Watercolor Morph - Two-Cat Portrait", "land": true},
        {"art": "https://pocketry-site-media-744329357706.us-west1.run.app/nd/wm-cat-bobby.webp", "refs": ["https://pocketry-site-media-744329357706.us-west1.run.app/fn-ref-cat-bobby.webp"], "cap": "Watercolor Morph - Cat Portrait", "land": false},
        {"art": "https://pocketry-site-media-744329357706.us-west1.run.app/nd/wm-cat-gingy-spotty.webp", "refs": ["https://pocketry-site-media-744329357706.us-west1.run.app/iw-ref-cat-gingy.webp", "https://pocketry-site-media-744329357706.us-west1.run.app/iw-ref-cat-spotty.webp"], "cap": "Watercolor Morph - Two-Cat Portrait", "land": true} ] },
    { head:"PET PARENT", forWho:"Dog & Cat Parents", bg:'#ffffff', items:[
        {"art": "https://pocketry-site-media-744329357706.us-west1.run.app/nd/pp-dog-hug.webp", "refs": ["https://pocketry-site-media-744329357706.us-west1.run.app/nd/ref-pp-dog-hug.webp"], "cap": "Pet Parent & Dog Portrait", "land": false},
        {"art": "https://pocketry-site-media-744329357706.us-west1.run.app/nd/pp-cat-fluffy.webp", "refs": ["https://pocketry-site-media-744329357706.us-west1.run.app/nd/ref-pp-cat-fluffy.webp"], "cap": "Pet Parent & Cat Portrait", "land": false},
        {"art": "https://pocketry-site-media-744329357706.us-west1.run.app/nd/pp-two-dogs.webp", "refs": ["https://pocketry-site-media-744329357706.us-west1.run.app/nd/ref-pp-two-dogs.webp"], "cap": "Pet Parent & Dogs Portrait", "land": false},
        {"art": "https://pocketry-site-media-744329357706.us-west1.run.app/nd/pp-cat-grandma.webp", "refs": ["https://pocketry-site-media-744329357706.us-west1.run.app/nd/ref-pp-cat-grandma.webp"], "cap": "Pet Parent & Cat Portrait", "land": false} ] },
    { head:"ENGAGEMENT & ANNIVERSARY", forWho:"Couples", bg:'#ffffff', items:[
        {"art": "https://pocketry-site-media-744329357706.us-west1.run.app/nd/eng-beach.webp", "refs": ["https://pocketry-site-media-744329357706.us-west1.run.app/nd/ref-eng-beach.webp"], "cap": "Watercolor Morph Engagement", "land": false},
        {"art": "https://pocketry-site-media-744329357706.us-west1.run.app/nd/ann-lakeside.webp", "refs": ["https://pocketry-site-media-744329357706.us-west1.run.app/nd/ref-ann-lakeside.webp"], "cap": "Watercolor Morph Anniversary", "land": false},
        {"art": "https://pocketry-site-media-744329357706.us-west1.run.app/nd/eng-ring.webp", "refs": ["https://pocketry-site-media-744329357706.us-west1.run.app/nd/ref-eng-ring.webp"], "cap": "Watercolor Morph Engagement", "land": false},
        {"art": "https://pocketry-site-media-744329357706.us-west1.run.app/nd/eng-eucalyptus.webp", "refs": ["https://pocketry-site-media-744329357706.us-west1.run.app/nd/ref-eng-eucalyptus.webp"], "cap": "Watercolor Morph Engagement", "land": false} ] },
    { head:"INK WASH", forWho:"Couples", bg:'#ffffff', items:[
        {"art": "https://pocketry-site-media-744329357706.us-west1.run.app/nd/ciw-couple_beach_proposal.webp", "refs": ["https://pocketry-site-media-744329357706.us-west1.run.app/nd/ref-ciw-couple_beach_proposal.webp"], "cap": "Couples Ink Wash Portrait", "land": false, "edge": true},
        {"art": "https://pocketry-site-media-744329357706.us-west1.run.app/nd/ciw-couple_ring_kiss.webp", "refs": ["https://pocketry-site-media-744329357706.us-west1.run.app/nd/ref-ciw-couple_ring_kiss.webp"], "cap": "Couples Ink Wash Portrait", "land": false, "edge": true},
        {"art": "https://pocketry-site-media-744329357706.us-west1.run.app/nd/ciw-couple_lakeside_embrace.webp", "refs": ["https://pocketry-site-media-744329357706.us-west1.run.app/nd/ref-ciw-couple_lakeside_embrace.webp"], "cap": "Couples Ink Wash Portrait", "land": false, "edge": true},
        {"art": "https://pocketry-site-media-744329357706.us-west1.run.app/nd/ciw-couple_eucalyptus_gate.webp", "refs": ["https://pocketry-site-media-744329357706.us-west1.run.app/nd/ref-ciw-couple_eucalyptus_gate.webp"], "cap": "Couples Ink Wash Portrait", "land": false, "edge": true} ] },
    { head:"WATERCOLOR MORPH", forWho:"Best Friends", bg:'#ffffff', items:[
        {"art": "https://pocketry-site-media-744329357706.us-west1.run.app/nd/bfwc-friends_2.webp", "refs": ["https://pocketry-site-media-744329357706.us-west1.run.app/nd/ref-bf-friends_2.webp"], "cap": "Best Friends Watercolor Morph", "land": false},
        {"art": "https://pocketry-site-media-744329357706.us-west1.run.app/nd/bfwc-friends_5.webp", "refs": ["https://pocketry-site-media-744329357706.us-west1.run.app/nd/ref-bf-friends_5.webp"], "cap": "Best Friends Watercolor Morph", "land": false},
        {"art": "https://pocketry-site-media-744329357706.us-west1.run.app/nd/bfwc-friends_6.webp", "refs": ["https://pocketry-site-media-744329357706.us-west1.run.app/nd/ref-bf-friends_6.webp"], "cap": "Best Friends Watercolor Morph", "land": false},
        {"art": "https://pocketry-site-media-744329357706.us-west1.run.app/nd/bfwc-friends_7.webp", "refs": ["https://pocketry-site-media-744329357706.us-west1.run.app/nd/ref-bf-friends_7.webp"], "cap": "Best Friends Watercolor Morph", "land": false} ] },
    { head:"INK WASH", forWho:"Best Friends", bg:'#ffffff', items:[
        {"art": "https://pocketry-site-media-744329357706.us-west1.run.app/nd/bfiw-friends_1.webp", "refs": ["https://pocketry-site-media-744329357706.us-west1.run.app/nd/ref-bf-friends_1.webp"], "cap": "Best Friends Ink Wash", "land": false, "edge": true},
        {"art": "https://pocketry-site-media-744329357706.us-west1.run.app/nd/bfiw-friends_3.webp", "refs": ["https://pocketry-site-media-744329357706.us-west1.run.app/nd/ref-bf-friends_3.webp"], "cap": "Best Friends Ink Wash", "land": false, "edge": true},
        {"art": "https://pocketry-site-media-744329357706.us-west1.run.app/nd/bfiw-friends_4.webp", "refs": ["https://pocketry-site-media-744329357706.us-west1.run.app/nd/ref-bf-friends_4.webp"], "cap": "Best Friends Ink Wash", "land": false, "edge": true},
        {"art": "https://pocketry-site-media-744329357706.us-west1.run.app/nd/bfiw-friends_6.webp", "refs": ["https://pocketry-site-media-744329357706.us-west1.run.app/nd/ref-bf-friends_6.webp"], "cap": "Best Friends Ink Wash", "land": false, "edge": true} ] },
    { head:"FLAT VECTOR", forWho:"Best Friends", bg:'#ffffff', items:[
        {"art": "https://pocketry-site-media-744329357706.us-west1.run.app/nd/bfarch-pair_waterfront.webp", "refs": ["https://pocketry-site-media-744329357706.us-west1.run.app/nd/ref-bf-friends_2.webp"], "cap": "Best Friends Flat Vector", "land": false},
        {"art": "https://pocketry-site-media-744329357706.us-west1.run.app/nd/bfarch-trio_ivy__besties.webp", "refs": ["https://pocketry-site-media-744329357706.us-west1.run.app/nd/ref-bf-friends_6.webp"], "cap": "Best Friends Flat Vector", "land": false},
        {"art": "https://pocketry-site-media-744329357706.us-west1.run.app/nd/bfarch-pair_waterfront__sisters.webp", "refs": ["https://pocketry-site-media-744329357706.us-west1.run.app/nd/ref-bf-friends_2.webp"], "cap": "Best Friends Flat Vector", "land": false},
        {"art": "https://pocketry-site-media-744329357706.us-west1.run.app/nd/bfarch-trio_ivy__the-squad.webp", "refs": ["https://pocketry-site-media-744329357706.us-west1.run.app/nd/ref-bf-friends_6.webp"], "cap": "Best Friends Flat Vector", "land": false} ] },
    { head:"STICKER", forWho:"Best Friends", bg:'#ffffff', items:[
        {"art": "https://pocketry-site-media-744329357706.us-west1.run.app/nd/bfst-friends_2-pink.webp", "refs": ["https://pocketry-site-media-744329357706.us-west1.run.app/nd/ref-bf-friends_2.webp"], "cap": "Best Friends Sticker", "land": false},
        {"art": "https://pocketry-site-media-744329357706.us-west1.run.app/nd/bfst-friends_3-purple.webp", "refs": ["https://pocketry-site-media-744329357706.us-west1.run.app/nd/ref-bf-friends_3.webp"], "cap": "Best Friends Sticker", "land": false},
        {"art": "https://pocketry-site-media-744329357706.us-west1.run.app/nd/bfst-friends_5-teal.webp", "refs": ["https://pocketry-site-media-744329357706.us-west1.run.app/nd/ref-bf-friends_5.webp"], "cap": "Best Friends Sticker", "land": false},
        {"art": "https://pocketry-site-media-744329357706.us-west1.run.app/nd/bfst-friends_7-pink.webp", "refs": ["https://pocketry-site-media-744329357706.us-west1.run.app/nd/ref-bf-friends_7.webp"], "cap": "Best Friends Sticker", "land": false} ] },
    { head:"HOME PORTRAITS", forWho:"Homes", bg:'#ffffff', items:[
        {"art": "https://pocketry-site-media-744329357706.us-west1.run.app/nd/home-one.webp", "refs": ["https://pocketry-site-media-744329357706.us-west1.run.app/nd/ref-home-craftsman.webp"], "cap": "One Home - Watercolor Morph", "land": true},
        {"art": "https://pocketry-site-media-744329357706.us-west1.run.app/nd/home-two.webp", "refs": ["https://pocketry-site-media-744329357706.us-west1.run.app/nd/ref-home-red.webp", "https://pocketry-site-media-744329357706.us-west1.run.app/nd/ref-home-blue.webp"], "cap": "Two Homes - Watercolor Morph", "land": true},
        {"art": "https://pocketry-site-media-744329357706.us-west1.run.app/nd/home-three-sepia.webp", "refs": ["https://pocketry-site-media-744329357706.us-west1.run.app/nd/ref-home-villa.webp", "https://pocketry-site-media-744329357706.us-west1.run.app/nd/ref-home-blue.webp", "https://pocketry-site-media-744329357706.us-west1.run.app/nd/ref-home-craftsman.webp"], "cap": "Three Homes - Sepia", "land": true},
        {"art": "https://pocketry-site-media-744329357706.us-west1.run.app/nd/home-one-bw.webp", "refs": ["https://pocketry-site-media-744329357706.us-west1.run.app/nd/ref-home-victorian.webp"], "cap": "One Home - Black & White", "land": true} ] },
    { head:"NATIONAL PARK COLLECTION", forWho:"Travelers", bg:'#ffffff', items:[
        {"art": "https://pocketry-site-media-744329357706.us-west1.run.app/nd/np-grand-canyon.webp", "refs": ["https://pocketry-site-media-744329357706.us-west1.run.app/nd/ref-np-couple.webp"], "cap": "Grand Canyon National Park", "land": false},
        {"art": "https://pocketry-site-media-744329357706.us-west1.run.app/nd/np-yosemite.webp", "refs": ["https://pocketry-site-media-744329357706.us-west1.run.app/nd/ref-np-couple.webp"], "cap": "Yosemite National Park", "land": false},
        {"art": "https://pocketry-site-media-744329357706.us-west1.run.app/nd/np-acadia.webp", "refs": ["https://pocketry-site-media-744329357706.us-west1.run.app/nd/ref-np-couple.webp"], "cap": "Acadia National Park", "land": false},
        {"art": "https://pocketry-site-media-744329357706.us-west1.run.app/nd/np-olympic.webp", "refs": ["https://pocketry-site-media-744329357706.us-west1.run.app/nd/ref-np-couple.webp"], "cap": "Olympic National Park", "land": false} ] }
  ];


  /* owner 2026-10-12: real product photos from the Oct 9–11 office shoot replace the flat renders wherever we shot that
     design (build_shoot_photos_page.py). Photo tiles first, then any remaining renders, row length unchanged. */
  const SHOOT = {
"FASHION NAME SERIES|Dogs": [
{
"photo": "https://pocketry-site-media-744329357706.us-west1.run.app/shoot-sofia/04-ham-rp",
"cap": "Fashion Name Blue - Dog Portrait"
},
{
"photo": "https://pocketry-site-media-744329357706.us-west1.run.app/shoot-sofia/04-lucy-rp",
"cap": "Fashion Name Pink - Dog Portrait"
},
{
"photo": "https://pocketry-site-media-744329357706.us-west1.run.app/shoot-sofia/04-milton-rp",
"cap": "Fashion Name Purple - Dog Portrait"
},
{
"photo": "https://pocketry-site-media-744329357706.us-west1.run.app/shoot-sofia/04-monty-rp",
"cap": "Fashion Name Teal - Dog Portrait"
}
],
"OUTFIT COLLECTION|Dogs": [
{
"photo": "https://pocketry-site-media-744329357706.us-west1.run.app/shoot-sofia/oc-king_french-bulldog-rp",
"cap": "The King - Dog Portrait"
},
{
"photo": "https://pocketry-site-media-744329357706.us-west1.run.app/shoot-sofia/oc-nurse_leo-rp",
"cap": "The Nurse - Dog Portrait"
},
{
"photo": "https://pocketry-site-media-744329357706.us-west1.run.app/shoot-sofia/oc-princess_white-maltese-rp",
"cap": "The Princess - Dog Portrait"
},
{
"photo": "https://pocketry-site-media-744329357706.us-west1.run.app/shoot-sofia/oc-ballerina_doodle-rp",
"cap": "The Ballet Dancer - Dog Portrait"
}
],
"INK WASH SERIES|Dogs": [
{
"photo": "https://pocketry-site-media-744329357706.us-west1.run.app/shoot-sofia/03-pets_lucy-rp",
"cap": "Ink Wash Purple - Dog Portrait"
},
{
"photo": "https://pocketry-site-media-744329357706.us-west1.run.app/shoot-sofia/03-pet-pairs_cava-malti-rp",
"cap": "Ink Wash Orange - Two-Dog Portrait"
},
{
"photo": "https://pocketry-site-media-744329357706.us-west1.run.app/shoot-sofia/03-pets_warren-rp",
"cap": "Ink Wash Orange - Dog Portrait"
},
{
"photo": "https://pocketry-site-media-744329357706.us-west1.run.app/shoot-sofia/synth-iw-dog-guapo-ham-teal",
"cap": "Ink Wash Teal - Two-Dog Portrait"
}
],
"WATERCOLOR MORPH|Dogs": [
{
"photo": "https://pocketry-site-media-744329357706.us-west1.run.app/shoot-sofia/01-pets_lucy-rp",
"cap": "Watercolor Morph - Dog Portrait"
},
{
"photo": "https://pocketry-site-media-744329357706.us-west1.run.app/shoot-sofia/01-pet-pairs_monty-malti-rp",
"cap": "Watercolor Morph - Two-Dog Portrait"
},
{
"photo": "https://pocketry-site-media-744329357706.us-west1.run.app/shoot-sofia/01-pets_leo-rp",
"cap": "Watercolor Morph - Dog Portrait"
},
{
"photo": "https://pocketry-site-media-744329357706.us-west1.run.app/shoot-sofia/01-pet-pairs_luke-moose-rp",
"cap": "Watercolor Morph - Two-Dog Portrait"
}
],
"FASHION NAME SERIES|Cats": [
{
"photo": "https://pocketry-site-media-744329357706.us-west1.run.app/shoot-sofia/04-bobby-rp",
"cap": "Fashion Name Purple - Cat Portrait"
},
{
"photo": "https://pocketry-site-media-744329357706.us-west1.run.app/shoot-sofia/04-gingy-rp",
"cap": "Fashion Name Pink - Cat Portrait"
},
{
"photo": "https://pocketry-site-media-744329357706.us-west1.run.app/shoot-sofia/04-spotty-rp",
"cap": "Fashion Name Purple - Cat Portrait"
},
{
"photo": "https://pocketry-site-media-744329357706.us-west1.run.app/shoot-sofia/04-jonah-rp",
"cap": "Fashion Name Orange - Cat Portrait"
}
],
"OUTFIT COLLECTION|Cats": [
{
"photo": "https://pocketry-site-media-744329357706.us-west1.run.app/shoot-sofia/oc-king_orange-tabby-cat-rp",
"cap": "The King - Cat Portrait"
},
{
"photo": "https://pocketry-site-media-744329357706.us-west1.run.app/shoot-sofia/oc-nurse_spotty-rp",
"cap": "The Nurse - Cat Portrait"
},
{
"photo": "https://pocketry-site-media-744329357706.us-west1.run.app/shoot-sofia/oc-angel_spotty-rp",
"cap": "The Angel - Cat Portrait"
},
{
"photo": "https://pocketry-site-media-744329357706.us-west1.run.app/shoot-sofia/oc-ballerina_tabby-cat-rp",
"cap": "The Ballet Dancer - Cat Portrait"
}
],
"INK WASH SERIES|Cats": [
{
"photo": "https://pocketry-site-media-744329357706.us-west1.run.app/shoot-sofia/03-pets_siam-rp",
"cap": "Ink Wash Blue - Cat Portrait"
},
{
"photo": "https://pocketry-site-media-744329357706.us-west1.run.app/shoot-sofia/03-pet-pairs_gingy-macky-rp",
"cap": "Ink Wash Blue - Two-Cat Portrait"
},
{
"photo": "https://pocketry-site-media-744329357706.us-west1.run.app/shoot-sofia/synth-iw-cat-bobby-jonah-pink",
"cap": "Ink Wash Pink - Two-Cat Portrait"
},
{
"photo": "https://pocketry-site-media-744329357706.us-west1.run.app/shoot-sofia/synth-iw-cat-tabitha-orange",
"cap": "Ink Wash Orange - Cat Portrait"
}
],
"WATERCOLOR MORPH|Cats": [
{
"photo": "https://pocketry-site-media-744329357706.us-west1.run.app/shoot-sofia/01-pets_siam-rp",
"cap": "Watercolor Morph - Cat Portrait"
},
{
"photo": "https://pocketry-site-media-744329357706.us-west1.run.app/shoot-sofia/01-pet-pairs_siam-macky-rp",
"cap": "Watercolor Morph - Two-Cat Portrait"
},
{
"photo": "https://pocketry-site-media-744329357706.us-west1.run.app/shoot-sofia/01-pets_bobby-rp",
"cap": "Watercolor Morph - Cat Portrait"
},
{
"photo": "https://pocketry-site-media-744329357706.us-west1.run.app/shoot-sofia/01-pet-pairs_gingy-spotty-rp",
"cap": "Watercolor Morph - Two-Cat Portrait"
}
],
"PET PARENT|Dog & Cat Parents": [   /* owner 2026-10-17: orange wall recolored light blue (recolor_wall_blue.py); originals = same name without -blue */
{
"photo": "https://pocketry-site-media-744329357706.us-west1.run.app/shoot-sofia/01-pet-parent_sofia-milo-rp",
"cap": "Pet Parent & Dog Portrait"
},
{
"photo": "https://pocketry-site-media-744329357706.us-west1.run.app/shoot-sofia/01-pet-parent_linh-snow-rp",
"cap": "Pet Parent & Cat Portrait"
},
{
"photo": "https://pocketry-site-media-744329357706.us-west1.run.app/shoot-sofia/01-pet-parent_carlos-oscar-frida-rp",
"cap": "Pet Parent & Dogs Portrait"
},
{
"photo": "https://pocketry-site-media-744329357706.us-west1.run.app/shoot-sofia/01-pet-parent_leyla-mango-pita-rp",
"cap": "Pet Parent & Cats Portrait"
}
],
"ENGAGEMENT & ANNIVERSARY|Couples": [
{
"photo": "https://pocketry-site-media-744329357706.us-west1.run.app/shoot-sofia/01-engagement_samuel-jennifer-rp",
"cap": "Watercolor Morph Engagement"
},
{
"photo": "https://pocketry-site-media-744329357706.us-west1.run.app/shoot-sofia/01-anniversary_marcus-elena-rp",
"cap": "Watercolor Morph Anniversary"
},
{
"photo": "https://pocketry-site-media-744329357706.us-west1.run.app/shoot-sofia/01-engagement_daniel-sofia-rp",
"cap": "Watercolor Morph Engagement"
},
{
"photo": "https://pocketry-site-media-744329357706.us-west1.run.app/shoot-sofia/01-anniversary_lucas-claire-rp",
"cap": "Watercolor Morph Anniversary"
}
],
"INK WASH|Couples": [
{
"photo": "https://pocketry-site-media-744329357706.us-west1.run.app/shoot-sofia/03-couples_andre-camila-rp",
"cap": "Couples Ink Wash Portrait"
},
{
"photo": "https://pocketry-site-media-744329357706.us-west1.run.app/shoot-sofia/synth-ciw-beach-proposal",
"cap": "Couples Ink Wash Portrait"
},
{
"photo": "https://pocketry-site-media-744329357706.us-west1.run.app/shoot-sofia/synth-ciw-ring-kiss",
"cap": "Couples Ink Wash Portrait"
},
{
"photo": "https://pocketry-site-media-744329357706.us-west1.run.app/shoot-sofia/synth-ciw-lakeside",
"cap": "Couples Ink Wash Portrait"
}
],
"WATERCOLOR MORPH|Best Friends": [
{
"photo": "https://pocketry-site-media-744329357706.us-west1.run.app/shoot-sofia/01-best-friends_besties_hannah-olivia-mia-rp",
"cap": "Best Friends Watercolor Morph"
},
{
"photo": "https://pocketry-site-media-744329357706.us-west1.run.app/shoot-sofia/01-best-friends_the-squad_leo-jamal-kenji-rp",
"cap": "Best Friends Watercolor Morph"
},
{
"photo": "https://pocketry-site-media-744329357706.us-west1.run.app/shoot-sofia/synth-bfwc-friends2",
"cap": "Best Friends Watercolor Morph"
},
{
"photo": "https://pocketry-site-media-744329357706.us-west1.run.app/shoot-sofia/synth-bfwc-friends5",
"cap": "Best Friends Watercolor Morph"
}
],
"INK WASH|Best Friends": [
{
"photo": "https://pocketry-site-media-744329357706.us-west1.run.app/shoot-sofia/03-best-friends_best-friends_mei-sora-rp",
"cap": "Best Friends Ink Wash"
},
{
"photo": "https://pocketry-site-media-744329357706.us-west1.run.app/shoot-sofia/synth-bfiw-friends1",
"cap": "Best Friends Ink Wash"
},
{
"photo": "https://pocketry-site-media-744329357706.us-west1.run.app/shoot-sofia/synth-bfiw-friends3",
"cap": "Best Friends Ink Wash"
},
{
"photo": "https://pocketry-site-media-744329357706.us-west1.run.app/shoot-sofia/synth-bfiw-friends4",
"cap": "Best Friends Ink Wash"
}
],
"FLAT VECTOR|Best Friends": [
{
"photo": "https://pocketry-site-media-744329357706.us-west1.run.app/shoot-sofia/06-besties_hannah-olivia-mia-rp",
"cap": "Best Friends Flat Vector"
},
{
"photo": "https://pocketry-site-media-744329357706.us-west1.run.app/shoot-sofia/synth-bfarch-waterfront",
"cap": "Best Friends Flat Vector"
},
{
"photo": "https://pocketry-site-media-744329357706.us-west1.run.app/shoot-sofia/synth-bfarch-ivy-squad",
"cap": "Best Friends Flat Vector"
},
{
"photo": "https://pocketry-site-media-744329357706.us-west1.run.app/shoot-sofia/synth-bfarch-waterfront-sisters",
"cap": "Best Friends Flat Vector"
}
],
"STICKER|Best Friends": [
{
"photo": "https://pocketry-site-media-744329357706.us-west1.run.app/shoot-sofia/05-best-friends_amara-zuri-rp",
"cap": "Best Friends Sticker"
},
{
"photo": "https://pocketry-site-media-744329357706.us-west1.run.app/shoot-sofia/05-best-friends_priya-anika-rp",
"cap": "Best Friends Sticker"
},
{
"photo": "https://pocketry-site-media-744329357706.us-west1.run.app/shoot-sofia/synth-bfst-friends3-purple",
"cap": "Best Friends Sticker"
},
{
"photo": "https://pocketry-site-media-744329357706.us-west1.run.app/shoot-sofia/synth-bfst-friends7-pink",
"cap": "Best Friends Sticker"
}
],
"HOME PORTRAITS|Homes": [
{
"photo": "https://pocketry-site-media-744329357706.us-west1.run.app/shoot-sofia/01-homes_one-home_the-reynolds-family_des-moines-rp",
"cap": "One Home - Watercolor Morph"
},
{
"photo": "https://pocketry-site-media-744329357706.us-west1.run.app/shoot-sofia/01-homes_two-homes_the-reynolds-family_ames-rp",
"cap": "Two Homes - Watercolor Morph"
},
{
"photo": "https://pocketry-site-media-744329357706.us-west1.run.app/shoot-sofia/01-homes_three-homes_the-reynolds-family_ames-rp",
"cap": "Three Homes - Watercolor Morph"
},
{
"photo": "https://pocketry-site-media-744329357706.us-west1.run.app/shoot-sofia/01-homes_four-homes_the-reynolds-family_ames-rp",
"cap": "Four Homes - Watercolor Morph"
}
],
"NATIONAL PARK COLLECTION|Travelers": [
{
"photo": "https://pocketry-site-media-744329357706.us-west1.run.app/shoot-sofia/07-grand-canyon-v18",
"cap": "Grand Canyon National Park"
},
{
"photo": "https://pocketry-site-media-744329357706.us-west1.run.app/shoot-sofia/07-yosemite-v18",
"cap": "Yosemite National Park"
},
{
"photo": "https://pocketry-site-media-744329357706.us-west1.run.app/shoot-sofia/07-acadia-v18",
"cap": "Acadia National Park"
},
{
"photo": "https://pocketry-site-media-744329357706.us-west1.run.app/shoot-sofia/07-olympic-v18",
"cap": "Olympic National Park"
}
]
};
  GROUPS.forEach(g => { const s = SHOOT[g.head + '|' + g.forWho]; if (!s || !g.items) return;
    g.items = s.concat(g.items.slice(s.length)).slice(0, Math.max(g.items.length, s.length)); });   /* shoot + synth tiles first; leftover renders only if a row is short */
  const photoTile = (o) => `
        <figure class="tile">
          <div class="tile__box tile__box--photo"><img src="${o.photo}-800.webp" srcset="${o.photo}-800.webp 800w, ${o.photo}-1600.webp 1600w"
               sizes="(max-width: 700px) 50vw, 25vw" width="800" height="800" alt="${o.cap} - real Pocketry panel with the original photo"
               loading="lazy" decoding="async"></div>
          <figcaption class="tile__cap">${o.cap}</figcaption>
        </figure>`;

  const realTile = (o,bg) => `
        <figure class="tile">
          <div class="tile__box" style="background:${bg}">
            <div class="tile__art"><img src="oc-art-${o.slug}.webp" width="800" height="999"
                 alt="${o.name} portrait of ${o.dog}" loading="lazy" decoding="async"></div>
            <div class="tile__ph"><img src="oc-ref-${o.slug}.webp" width="400" height="500"
                 alt="The original photo of ${o.dog}" loading="lazy" decoding="async"></div>
          </div>
          <figcaption class="tile__cap">${o.name} - ${o.species||'Dog'} Portrait</figcaption>
        </figure>`;

  const artTile = (o,bg) => `
        <figure class="tile">
          <div class="tile__box" style="background:${bg}"${o.land ? ' data-o="landscape"' : ''}${(o.style === 'Ink Wash' || o.edge || o.cap) ? ' data-edge' : ''}>
            <div class="tile__art"><img src="${o.art}"
                 alt="${o.cap || (o.name + (o.style ? '' : ' papercut') + ' portrait of ' + o.dog)}" loading="lazy" decoding="async"></div>
            ${o.refs.map((r,i)=>`<div class="tile__ph" data-slot="${i+2}"><img src="${r}"
                 alt="The original photo${o.dog ? ' of ' + o.dog.split(' & ')[i] : ''}" loading="lazy" decoding="async"></div>`).join('')}
          </div>
          <figcaption class="tile__cap">${o.cap ? o.cap : `${o.name} - ${o.refs.length===2 ? 'Two-'+(o.species||'Dog') : (o.species||'Dog')} Portrait`}</figcaption>
        </figure>`;

  const blankTile = (c,bg) =>
        `<figure class="tile"><div class="tile__box"${bg ? ` style="background:${bg}"` : ''}></div>` +
        `<figcaption class="tile__cap">${c}</figcaption></figure>`;

  const slug = s => (s||'').toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'');
  const tileGroup = g => `
    <section class="tiles-section${g.head ? '' : ' tiles-section--cont'}"${g.head ? ` id="${slug(g.head + (g.forWho ? ' for ' + g.forWho : ''))}"` : ''}>
      ${g.head ? `<h2 class="tiles-head"><span class="tiles-head__t">${g.head}${g.forWho ? `<span class="for">For ${g.forWho}</span>` : ''}</span>${g.script ? `<a class="script" href="#">${g.script}</a>` : ''}</h2>` : ''}
      <div class="tiles">` +
        (g.items ? g.items.map(o=>(o.photo ? photoTile : o.art ? artTile : realTile)(o,g.bg)).join('') : g.caps.map(c=>blankTile(c,g.bg)).join('')) + `</div>
    </section>`;

  /* room strips — generated by build_room_strips.py (https://pocketry-site-media-744329357706.us-west1.run.app/room-strips.json); a = aspect, w = web widths made */
  const ROOM_STRIPS = {"fashion_name": [{"key": "fn-gallerywall", "a": 1.4906, "w": [600, 1000, 1600, 2400], "alt": "A gallery wall of Pocketry Fashion Name panels above a sofa (mockup)"}, {"key": "fn-sizes", "a": 1.9497, "w": [600, 1000, 1600, 2400], "alt": "Fashion Name panels in four sizes leaning on a counter (mockup)"}, {"key": "fn-shelf", "a": 0.75, "w": [600, 1000], "alt": "A Fashion Name panel leaning on a shelf (mockup)"}], "outfits": [{"key": "oc-gallerywall", "a": 1.4955, "w": [600, 1000, 1600, 2400], "alt": "A gallery wall of Pocketry outfit panels above a sofa"}, {"key": "oc-kitchen", "a": 0.75, "w": [600, 1000, 1600, 2400], "alt": "A Pocketry King panel in a kitchen"}, {"key": "oc-hamchef", "a": 0.75, "w": [600, 1000, 1600, 2400], "alt": "Ham beside his Pocketry Chef panel"}, {"key": "oc-miltonking", "a": 1.0352, "w": [600, 1000, 1600, 2400], "alt": "Milton beside his Pocketry King panel"}]};
  const roomStrip = g => {
    if(g.strip==='placeholder') return `
    <section class="room-strip" aria-hidden="true"><div class="rs-row">${[1.6,1.95,0.75].map(a=>
      `<div class="rs-item rs-item--ph" style="--a:${a}">Room photos to come — ${g.label}</div>`).join('')}</div></section>`;
    const items = ROOM_STRIPS[g.strip], sum = items.reduce((s,i)=>s+i.a,0);
    return `
    <section class="room-strip"><div class="rs-row">${items.map(i=>`
      <div class="rs-item" style="--a:${i.a}"><img src="strip-${i.key}-web-${i.w[Math.min(1,i.w.length-1)]}.webp"
           srcset="${i.w.map(w=>`strip-${i.key}-web-${w}.webp ${w}w`).join(', ')}" sizes="${(100*i.a/sum).toFixed(1)}vw"
           alt="${i.alt}" loading="lazy" decoding="async"></div>`).join('')}</div></section>`;
  };

  const tiles = () => GROUPS.filter(g => !g.hidden).map(g => g.strip ? roomStrip(g) : tileGroup(g)).join('');

  const page = () => topBars() + `
    <section class="room-hero" aria-label="Pocketry portraits at home"><style>section.room-hero img.b,section.room-hero img.c,section.room-hero img.d,section.room-hero img.e{position:absolute;inset:0;opacity:0}section.room-hero img.b{animation:heroB5 30s ease-in-out infinite}section.room-hero img.c{animation:heroC5 30s ease-in-out infinite}section.room-hero img.d{animation:heroD5 30s ease-in-out infinite}section.room-hero img.e{animation:heroE5 30s ease-in-out infinite}@keyframes heroB5{0%,16.7%{opacity:0}20%,36.7%{opacity:1}40%,100%{opacity:0}}@keyframes heroC5{0%,36.7%{opacity:0}40%,56.7%{opacity:1}60%,100%{opacity:0}}@keyframes heroD5{0%,56.7%{opacity:0}60%,76.7%{opacity:1}80%,100%{opacity:0}}@keyframes heroE5{0%,76.7%{opacity:0}80%,96.7%{opacity:1}100%{opacity:0}}@media (prefers-reduced-motion: reduce){section.room-hero img.b,section.room-hero img.c,section.room-hero img.d,section.room-hero img.e{animation:none}}</style><figure><img class="a" src="https://pocketry-site-media-744329357706.us-west1.run.app/room-hero/king-unwrap-wide-600.webp" srcset="https://pocketry-site-media-744329357706.us-west1.run.app/room-hero/king-unwrap-wide-600.webp 600w, https://pocketry-site-media-744329357706.us-west1.run.app/room-hero/king-unwrap-wide-1200.webp 1200w" sizes="50vw" width="600" height="400" alt="Unwrapping a Pocketry The King outfit dog portrait"><img class="b" src="https://pocketry-site-media-744329357706.us-west1.run.app/room-hero/samuel-jennifer-oil-console-zoom3-600.webp" srcset="https://pocketry-site-media-744329357706.us-west1.run.app/room-hero/samuel-jennifer-oil-console-zoom3-600.webp 600w, https://pocketry-site-media-744329357706.us-west1.run.app/room-hero/samuel-jennifer-oil-console-zoom3-1200.webp 1200w" sizes="50vw" width="600" height="400" alt="An Oil Painting Style engagement portrait of Samuel and Jennifer on a travertine console"><img class="c" src="https://pocketry-site-media-744329357706.us-west1.run.app/room-hero/hawaii-shelf-wide-600.webp" srcset="https://pocketry-site-media-744329357706.us-west1.run.app/room-hero/hawaii-shelf-wide-600.webp 600w, https://pocketry-site-media-744329357706.us-west1.run.app/room-hero/hawaii-shelf-wide-1200.webp 1200w" sizes="50vw" width="600" height="400" alt="A vintage-style Hawaii travel poster with a trip photo on a shelf"><img class="d" src="https://pocketry-site-media-744329357706.us-west1.run.app/room-hero/ethan-olivia-unwrap-wide-600.webp" srcset="https://pocketry-site-media-744329357706.us-west1.run.app/room-hero/ethan-olivia-unwrap-wide-600.webp 600w, https://pocketry-site-media-744329357706.us-west1.run.app/room-hero/ethan-olivia-unwrap-wide-1200.webp 1200w" sizes="50vw" width="600" height="400" alt="Unwrapping a Pocketry watercolor style engagement portrait of Ethan and Olivia"><img class="e" src="https://pocketry-site-media-744329357706.us-west1.run.app/room-hero/omar-miso-ginger-shelf-zoom2-600.webp" srcset="https://pocketry-site-media-744329357706.us-west1.run.app/room-hero/omar-miso-ginger-shelf-zoom2-600.webp 600w, https://pocketry-site-media-744329357706.us-west1.run.app/room-hero/omar-miso-ginger-shelf-zoom2-1200.webp 1200w" sizes="50vw" width="600" height="400" alt="A watercolor style Pet Parent & Cat portrait of Omar, Miso and Ginger on a shelf"></figure><figure><img class="a" src="https://pocketry-site-media-744329357706.us-west1.run.app/room-hero/paris-tall-shelf-zoom2-600.webp" srcset="https://pocketry-site-media-744329357706.us-west1.run.app/room-hero/paris-tall-shelf-zoom2-600.webp 600w, https://pocketry-site-media-744329357706.us-west1.run.app/room-hero/paris-tall-shelf-zoom2-1200.webp 1200w" sizes="50vw" width="600" height="400" alt="A vintage-style Paris travel poster with a trip photo on a bookshelf"><img class="b" src="https://pocketry-site-media-744329357706.us-west1.run.app/room-hero/silly-ballet-unwrap-wide2-600.webp" srcset="https://pocketry-site-media-744329357706.us-west1.run.app/room-hero/silly-ballet-unwrap-wide2-600.webp 600w, https://pocketry-site-media-744329357706.us-west1.run.app/room-hero/silly-ballet-unwrap-wide2-1200.webp 1200w" sizes="50vw" width="600" height="400" alt="Unwrapping a Pocketry The Ballet Dancer outfit cat portrait"><img class="c" src="https://pocketry-site-media-744329357706.us-west1.run.app/room-hero/emma-lily-console-zoom-600.webp" srcset="https://pocketry-site-media-744329357706.us-west1.run.app/room-hero/emma-lily-console-zoom-600.webp 600w, https://pocketry-site-media-744329357706.us-west1.run.app/room-hero/emma-lily-console-zoom-1200.webp 1200w" sizes="50vw" width="600" height="400" alt="A purple Ink Style Best Friends portrait of Emma and Lily on a console"><img class="d" src="https://pocketry-site-media-744329357706.us-west1.run.app/room-hero/lucy-fn-shelf-zoom-600.webp" srcset="https://pocketry-site-media-744329357706.us-west1.run.app/room-hero/lucy-fn-shelf-zoom-600.webp 600w, https://pocketry-site-media-744329357706.us-west1.run.app/room-hero/lucy-fn-shelf-zoom-1200.webp 1200w" sizes="50vw" width="600" height="400" alt="A pink Fashion Name dog portrait of Lucy on a kitchen shelf"><img class="e" src="https://pocketry-site-media-744329357706.us-west1.run.app/room-hero/mykonos-unwrap-wide2-600.webp" srcset="https://pocketry-site-media-744329357706.us-west1.run.app/room-hero/mykonos-unwrap-wide2-600.webp 600w, https://pocketry-site-media-744329357706.us-west1.run.app/room-hero/mykonos-unwrap-wide2-1200.webp 1200w" sizes="50vw" width="600" height="400" alt="Unwrapping a Pocketry Mykonos travel poster portrait"></figure><div class="room-hero__copy"><h1 class="room-hero__head"><span class="l1">Amazing Custom-Made</span> <span class="l2">Portraits From Your Photos</span></h1><p class="room-hero__sub"><span><u>Instantly</u> generate portrait previews</span> <span>in less than 2 minutes</span></p></div></section>
<section class="pk-intro" aria-label="One gift size, bundle and save">
  <div class="pk-col pk-left">
  <h2 class="pk-h">The Perfect Gift Size</h2>
  <img class="pk-gift" src="https://pocketry-site-media-744329357706.us-west1.run.app/intro/gift.svg" alt="" aria-hidden="true">
  <p class="pk-p">All of our custom portraits are high resolution prints on a rigid, ultra-lightweight panel, 3/16 inch thick, in an <b>11x14 inch</b> size. Clean, modern aesthetic.<br><br><a class="pk-link" href="/pages/our-process#why-11x14">Learn why we only make an 11x14 size.</a></p>
  </div>
  <div class="pk-col">
  <h2 class="pk-h">Bundle &amp; Save!</h2>
  <div class="pk-deal">
  <div class="pk-pills">
    <span class="pk-pill">1 portrait<b>$39</b></span>
    <span class="pk-pill">2 portraits<b>$35 each</b><i class="pk-off"><b>10%</b>OFF</i></span>
    <span class="pk-pill pk-best">3+ portraits<b>$30 each</b><i class="pk-off"><b>23%</b>OFF</i></span>
  </div>
  <p class="pk-mix">Mix &amp; match any of our portrait designs!</p>
  </div>
  </div>
  <div class="pk-col pk-left pk-bonus">
  <h2 class="pk-h">Free Bonus</h2>
  <img class="pk-gift" src="https://pocketry-site-media-744329357706.us-west1.run.app/intro/download.svg" alt="" aria-hidden="true">
  <p class="pk-p">Every portrait comes with our <b>Premium Download Package</b>: 22 digital files of your portrait for your phone, TV, social media and more. Includes a high-resolution print file. <b>$25 VALUE, FREE.</b></p>
  </div>
</section>
    ${tiles()}`;

  { const b = new URLSearchParams(location.search).get('bar'); if (b) document.body.dataset.bar = b; }
  document.getElementById('out').innerHTML = page();
  show(0);
  /* MODERN sized UP to the width of PET PORTRAITS (owner 2026-09-23: letter-spaced MODERN "doesn't look good ... maybe
     make MODERN a bigger font size than PET PORTRAITS"). Normal letter-spacing; the font size is scaled so the
     visible word spans exactly the width of line 2. The letter-spaced version is in git (fe21b70). */
  /* owner 2026-10-01: "change PET PORTRAITS to KEEPSAKES and use kerning to space out the letters so they are the same
     width as MODERN". MODERN's size is now fixed in CSS (1.742em); KEEPSAKES gets letter-spacing so its visible width
     matches MODERN. The trailing letter-space is cancelled with a negative right margin so the word stays centred. */
  function fitModern(){
    const l1=document.querySelector('.hero h1 .l1'), l2=document.querySelector('.hero h1 .l2');
    if(!l1||!l2) return;
    l2.style.letterSpacing='0px'; l2.style.marginRight='0px';
    const r=document.createRange();
    const w=el=>{r.selectNodeContents(el); return r.getBoundingClientRect().width;};
    const gaps=l2.textContent.trim().length-1;
    const ls=Math.max(0,(w(l1)-w(l2))/gaps);
    l2.style.letterSpacing=ls+'px'; l2.style.marginRight=(-ls)+'px';
  }
  (document.fonts ? document.fonts.ready : Promise.resolve()).then(fitModern);
  addEventListener('resize', fitModern);
  rotate(4000);          /* Photo change  4s */
})();
